import { connect } from 'react-redux';
import { IApplicationState } from '../../../../../../../types/types';
import { ICardHOCProps } from '../CardHOC/types';
import { CardStartDate } from '../../components/CardStartDate/CardStartDate';
import { getUserTimeFormat12 } from '../../../../../../../store/model/authUser/selectors/getUserTimeFormat12';
import { onDateChange } from '../events/onDateChange';
import { onLoadCard } from '../events/onLoadCard';
import { ICardStartDateEvents, ICardStartDateFields } from '../../components/CardStartDate/types';
import { getCard } from '../../../../../../../store/model/selectors/getCard';
import {
    getBoardMetaDefaultDueDateTime
} from '../../../../../../../store/model/selectors/getBoardMetaDefaultDueDateTime';
import {
    getBoardMetaDefaultStartDateTime
} from '../../../../../../../store/model/selectors/getBoardMetaDefaultStartDateTime';
import { getCardIsEpic } from '../../../../../../../store/model/selectors/getCardIsEpic';
import {
    getBoardIsCardRequiredProperty
} from '../../../../../../../store/model/board/selectors/getBoardIsCardRequiredProperty';
import { EAsidePanelProperty } from '../../../../../aside_panel/asidePanel/components/AsidePanel/types';
import { getCardDateReadonly } from '../CardDueDateHOC/selectors/getCardDateReadonly';

const mapStateToProps = (
    state: IApplicationState,
    { card, portalId }: ICardHOCProps
): ICardStartDateFields => {
    const { dueDate, startDate, processingPercent, cardId, dashboardId } = card;
    const cardFull = getCard(state, cardId);
    const isOverdue = dueDate && dueDate * 1000 < Date.now() && processingPercent !== 100;

    return {
        defaultDueTime: getBoardMetaDefaultDueDateTime(state, dashboardId),
        defaultStartTime: getBoardMetaDefaultStartDateTime(state, dashboardId),
        dueDate,
        isMilestone: cardFull && cardFull.isMilestone,
        startDate,
        isOverdue,
        isDisabled: getCardIsEpic(state, cardId),
        isDueRequired: getBoardIsCardRequiredProperty(state, dashboardId, EAsidePanelProperty.CARD_DUE_DATE),
        isReadonly: getCardDateReadonly(state, dashboardId, cardId),
        isStartRequired: getBoardIsCardRequiredProperty(state, dashboardId, EAsidePanelProperty.CARD_START_DATE),
        portalId,
        isUserTimeFormat12: getUserTimeFormat12(state)
    }
}

const mapDispatchToProps = (
    dispatch: any,
    { card }: ICardHOCProps
): ICardStartDateEvents => ({
    onLoadCard: () => dispatch(onLoadCard(card.cardId)),
    onChange: (date, dateType) => dispatch(onDateChange(card.cardId, date, dateType)),
})

export const CardStartDateHOC = connect(
    mapStateToProps,
    mapDispatchToProps
)(CardStartDate);
CardStartDateHOC.displayName = 'CardStartDateHOC';
